import {Component} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Moment} from 'moment';
import {FormBuilder, FormGroup} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {dateString, dateToDatetime, timeString} from '../helpers';
import {debounceTime, distinctUntilChanged, map} from 'rxjs/operators';
import {DateFormatPipe as DatePipe} from '../pipes/dateformat.pipe';
import {getUserFirstName, hasConfermaMantenimento} from '../../core/store/account/selectors';
import {Store} from '@ngrx/store';
import {FeatureService} from '../../features/dashboard/feature.service';

@Component({
  providers: [DatePipe],
  styles: [`
    h3 {
      margin-bottom: 20px;
      margin-top: 5px;
    }
  `],
  template: `

    <div class="plan_wrapper">
      <div class="plan_wrapper_calendar">
        <h3>{{ (viewDate$ | async | dateFormat: "EEEE dd MMMM yyyy") | titlecase }}</h3>

        <app-modal-calendar *ngIf="viewDate$ | async" [date]="viewDate$ | async"
                            (onSegmentClick)="handleSegmentClick($event)"></app-modal-calendar>
      </div>
      <div class="plan_wrapper_form">
        <div class="modal-header">
          <div class="d-flex align-items-center justify-content-between" style="width: 100%;">
            <h4 class="modal-title"><strong>Data appuntamento</strong></h4>
          </div>
        </div>
        <div class="modal-body">

          <app-agenda-disponibilita-mantenimento [tipologia]="'mantenimento'" class="mb-3"
                                                 *ngIf="showInfoMantenimento"
                                                 [clienteId]="clienteId$ | async"
                                                 [noteAggiuntive]=""></app-agenda-disponibilita-mantenimento>

          <form [formGroup]="form" (submit)="handleSubmit()">
            <!--<p>Seleziona la data dell'appuntamento:</p>-->
            <div class="form-group row">
              <label class="col-form-label">Data</label>
              <div class="control-input">
                <div>
                    <app-datetime-picker formControlName="data"></app-datetime-picker>
                </div>
              </div>
            </div>

            <div class="d-flex align-items-center mt-3">
              <p class="mb-0 mr-2">Durata</p>
              <app-field-durata formControlName="durata"></app-field-durata>
            </div>

            <div *ngIf="note" class="mt-3 mb-3">{{ note }}</div>

            <div *ngIf="pianificaFuturi">

              <label class="checkbox checkbox-success mt-5">
                <input type="checkbox" formControlName="calcola">
                <span></span>Calcola automaticamente le date dei prossimi appuntamenti.<br />
                <small style="display: block; margin-top: 5px;">Ricorda che il calcolo potrebbe coincidere con giorni di chiusura non ancora programmati o festività. Controllale sempre prima di confermarle al cliente.</small>
              </label>
            </div>

            <div class="form-group row mt-3" *ngIf="showConfirm && (hasConfermaMantenimento$ | async)">
              <label class="col-form-label">Stato</label>
              <div class="control-input">
                <div>
                  <select formControlName="stato" class="form-control" required>
                    <option value="scheduled">Appuntamento programmato</option>
                    <option value="to_be_confirmed">In attesa di conferma</option>
                    <option value="confirmed">Appuntamento confermato</option>
                  </select>
                </div>
                <div *ngIf="errors && errors.errors && errors.errors.stato"
                     class="invalid-feedback"
                     role="alert">
                  {{ errors.errors.stato[0] }}
                </div>
              </div>
            </div>

            <div class="form-group row mt-3" *ngIf="mostraOperatore">
              <label class="col-form-label">Operatore</label>
              <div class="control-input">
                <div>
                  <select formControlName="operatore_id" class="form-control">
                    <option [ngValue]="null">{{ userFirstName$ | async }}</option>
                    <option *ngFor="let operatore of sottoOperatori$ | async" [ngValue]="operatore.id">
                      {{ operatore.nome }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

          </form>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" (click)="modal.dismiss()">Chiudi</button>
          <button [disabled]="form.invalid" class="btn btn-primary" (click)="handleSubmit()">Conferma</button>
        </div>
      </div>
    </div>

  `
})

export class SelectDateModalComponent {

  public pianificaFuturi = false;
  public note = '';
  public showConfirm = false;
  public showInfoMantenimento = false;
  // Il chiamante lo attiva solo se il suo endpoint salva `operatore_id`.
  public showOperatore = false;
  public clienteId$: BehaviorSubject<number> = new BehaviorSubject(null);

  public form: FormGroup;
  viewDate$: BehaviorSubject<Date> = new BehaviorSubject(new Date());
  hasConfermaMantenimento$ = this.store.select(hasConfermaMantenimento);
  sottoOperatori$: BehaviorSubject<any[]> = new BehaviorSubject([]);
  userFirstName$ = this.store.select(getUserFirstName);

  constructor(private store: Store, public modal: NgbActiveModal, private fb: FormBuilder, private service: FeatureService) {

    this.form = this.fb.group({
      data: fb.control(dateToDatetime()),
      calcola: fb.control(false),
      durata: fb.control(1),
      stato: fb.control('scheduled'),
      operatore_id: fb.control(null),
    });

    this.service.getSottoOperatori().subscribe((res: any) => this.sottoOperatori$.next(res && res.data ? res.data : []));

    this.form.valueChanges.pipe(
      debounceTime(300),
      map(({ data }) => data),
      distinctUntilChanged(),
    ).subscribe((data) => {
      this.viewDate$.next(new Date(data));
    });

  }

  public setData(data: string) {

    this.form.patchValue({
      data
    });

  }

  public setStato(stato: string) {

    this.form.patchValue({
      stato
    });

  }

  get mostraOperatore(): boolean {

    return this.showOperatore && !!this.sottoOperatori$.value.length;

  }

  handleChange(date: Moment) {


  }

  handleSubmit() {

    this.modal.close(this.form.value);

  }

  handleSegmentClick($event: { date: Date; sourceEvent: MouseEvent }) {

    this.form.patchValue({
      data: `${dateString($event.date)} ${timeString($event.date)}:00`
    });

  }

}
